import React from "react";
import ReactQuill, { ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";

interface QuillWrapperProps extends ReactQuillProps {
  forwardedRef: React.Ref<ReactQuill>;
}

const QuillWrapper: React.FC<QuillWrapperProps> = ({ forwardedRef, ...props }) => {
  return <ReactQuill ref={forwardedRef} {...props} />;
};

export default QuillWrapper;
